import React from 'react'
import { EditRequirementFlowProvider } from './context/EditRequirementFlowProvider'
import { EditRequirementFlowMain } from './components/EditRequirementFlowMain'

export const EditRequirementFlow = () => {
  return (
    <EditRequirementFlowProvider>
      <EditRequirementFlowMain />
    </EditRequirementFlowProvider>
  )
}
